import { apiInstance } from '@/api/api.js'
import { DEFAULT_LANGUAGE } from '../../helpers/constants'

const api = apiInstance()

export default {
  async getTranslation(
    { commit, dispatch },
    {
      sourceLanguage = DEFAULT_LANGUAGE,
      sourceText = '',
      targetLanguage = DEFAULT_LANGUAGE,
    },
  ) {
    try {
      commit('setStartLoadingTranslatedString', { sourceLanguage, sourceText })
      const response = await api.post('/translations', {
        text: sourceText,
        sourceLanguage,
      })

      commit('addTranslatedString', {
        sourceLanguage: sourceLanguage,
        sourceText: sourceText,
        targetLanguage: targetLanguage,
        targetText: `${response?.data?.text || ''}`,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
    } finally {
      commit('setEndLoadingTranslatedString', { sourceLanguage, sourceText })
    }
  },
  async getTextToSpeech({ dispatch }, { text, language = DEFAULT_LANGUAGE }) {
    try {
      const response = await api.post(
        '/text-to-speech',
        { text, language },
        {
          responseType: 'blob',
        },
      )

      return response.data
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      return null
    }
  },
}
